import React from "react";
import PhoneNav from "../PhoneNav";
import Footer2 from "../Footer2";
import "./MediaPublications.css";

function MediaPublications(props) {
  const { mediaPublications, x135, x136, x139, x137, x138, viewMore, phoneNavProps, footer2Props } = props;

  return (
    <div className="media-publications-1 screen">
      <PhoneNav image22={phoneNavProps.image22} className={phoneNavProps.className} />
      <div className="frame-224">
        <div className="media-publications-2 poppins-medium-tundora-18px">{mediaPublications}</div>
      </div>
      <div className="frame-291">
        <div className="frame-288">
          <img className="x135" src={x135} />
        </div>
        <div className="frame-289">
          <img className="x136" src={x136} />
          <img className="x139" src={x139} />
        </div>
        <div className="frame-290">
          <img className="x137" src={x137} />
          <img className="x138" src={x138} />
        </div>
      </div>
      <div className="frame-292">
        <div className="frame-142">
          <div className="view-more poppins-medium-white-10px">{viewMore}</div>
        </div>
      </div>
      <Footer2 footer3Props={footer2Props.footer3Props} />
    </div>
  );
}

export default MediaPublications;
